<template>
  <div>
    <div class="search-bar">
      <Input v-model="searchQuery" placeholder="搜索模块名称或描述" clearable style="width: 300px" />
      <Button type="primary" @click="handleSearch" style="margin-left: 10px">搜索</Button>
      <Button type="success" @click="handleAdd" style="margin-left: 10px">新建模块</Button>
    </div>

    <div class="group-filter">
      <div
        class="group-item"
        :class="{'active': currentGroup === 'all'}"
        @click="handleGroupChange('all')"
      >
        全部
        <span class="count">{{ modules.length }}</span>
      </div>
      <div
        class="group-item"
        :class="{'active': currentGroup === ''}"
        @click="handleGroupChange('')"
      >
        未分组
        <span class="count">{{ getGroupModuleCount('') }}</span>
      </div>
      <div
        v-for="group in availableGroups"
        :key="group"
        class="group-item"
        :class="{'active': currentGroup === group}"
        @click="handleGroupChange(group)"
      >
        {{ group }}
        <span class="count">{{ getGroupModuleCount(group) }}</span>
      </div>
    </div>

    <div class="table-wrapper">
      <BaseTable
        :columns="columns"
        :data="filteredModules"
        :loading="loading"
        border
        @event="handleTableEvent"
      ></BaseTable>
    </div>

    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      @on-ok="handleSubmit"
      :loading="confirmLoading"
    >
      <Form ref="formRef" :model="formData" :rules="rules">
        <div class="form-section">
          <h3>基本信息</h3>
          <div class="form-row">
            <FormItem label="名称" name="name" class="form-item">
              <Input v-model="formData.name" placeholder="请输入模块名称" />
            </FormItem>
            <FormItem label="分组" name="group" class="form-item">
              <Select v-model="formData.group" filterable allow-create style="width: 100%">
                <Option value="" key="empty">未分组</Option>
                <Option v-for="group in availableGroups" :value="group" :key="group">{{ group }}</Option>
              </Select>
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="版本" name="version" class="form-item">
              <InputNumber v-model="formData.version" :min="1" style="width: 100%" />
            </FormItem>
            <FormItem label="图标" name="icon" class="form-item">
              <div class="icon-select-wrapper">
                <BaseIconSelect v-model="formData.icon" selectable />
              </div>
            </FormItem>
          </div>
          <FormItem label="描述" name="description">
            <Input type='textarea' v-model="formData.description" :rows="4" placeholder="请输入模块描述" />
          </FormItem>
        </div>

        <div class="form-section">
          <h3>路由配置</h3>
          <FormItem label="Base URL" name="base_url">
            <Input v-model="formData.base_url" placeholder="请输入基础URL" />
          </FormItem>
          <FormItem label="URL" name="url">
            <Input v-model="formData.url" placeholder="请输入访问URL" />
          </FormItem>
        </div>

        <div class="form-section">
          <h3>权限设置</h3>
          <div class="form-row">
            <FormItem label="私有" name="private" class="form-item">
              <i-switch v-model="formData.private" :true-value="1" :false-value="0"/>
            </FormItem>
            <FormItem label="开发中" name="developing" class="form-item">
              <i-switch v-model="formData.developing" :true-value="1" :false-value="0" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="公开权限等级" name="plevel" class="form-item">
              <BaseSelect v-model="formData.plevel" :options="plevelOptions" value-type="object" style="width: 100%" />
            </FormItem>
            <div class="form-item"></div>
          </div>
        </div>
      </Form>
    </Modal>

    <!-- 授权管理对话框 -->
    <Modal
      v-model="permissionModalVisible"
      title="授权管理"
      width="700"
    >
      <div class="perm-header">
        <div class="perm-module-info">
          <BaseIcon
            v-if="currentModule"
            :icon="currentModule.icon"
            style="font-size: 24px; margin-right: 10px;"
          />
          <div class="module-info-text">
            <h3>{{ currentModule ? currentModule.name : '' }}</h3>
            <span class="module-desc">{{ currentModule ? currentModule.description : '' }}</span>
          </div>
        </div>
        <div class="perm-actions">
          <Button type="primary" @click="showAddPermissionModal">新增授权</Button>
        </div>
      </div>

      <Table :columns="permissionColumns" :data="permissions" :loading="permissionLoading">
        <template slot="action" slot-scope="{ row }">
          <Button type="error" size="small" @click="handleDeletePermission(row)" style="color: #fff">删除</Button>
        </template>
      </Table>

      <div slot="footer">
        <Button @click="permissionModalVisible = false">关闭</Button>
      </div>
    </Modal>

    <!-- 添加授权对话框 -->
    <Modal
      v-model="addPermissionModalVisible"
      title="添加授权"
      width="600"
      @on-ok="handleAddPermission"
      :loading="addPermissionLoading"
    >
      <Form ref="addPermFormRef" :model="addPermissionForm" :rules="addPermissionRules">
        <div class="add-perm-form-row">
          <FormItem label="授权类型" name="clientType" class="add-perm-form-col">
            <ButtonGroup>
              <Button
                :type="addPermissionForm.clientType === 'user' ? 'primary' : 'default'"
                @click="handleSetClientType('user')"
              >
                用户
              </Button>
              <Button
                :type="addPermissionForm.clientType === 'role' ? 'primary' : 'default'"
                @click="handleSetClientType('role')"
              >
                角色
              </Button>
              <Button
                :type="addPermissionForm.clientType === 'group' ? 'primary' : 'default'"
                @click="handleSetClientType('group')"
              >
                群组
              </Button>
            </ButtonGroup>
          </FormItem>
          </div>
          <div class="add-perm-form-row">
          <FormItem label="授权对象" name="clientId" class="add-perm-form-col">
            <!-- 用户选择 -->
            <BaseUserSelectGrouped
              v-if="addPermissionForm.clientType === 'user'"
              v-model="addPermissionForm.clientId"
              placeholder="选择用户"
              style="width: 100%;"
            />

            <!-- 角色选择 - 按mod分组 -->
            <Select
              v-if="addPermissionForm.clientType === 'role'"
              v-model="addPermissionForm.clientId"
              placeholder="选择角色"
              style="width: 100%;"
              filterable
            >
              <OptionGroup v-for="(roleGroup, mod) in groupedRoles" :key="mod" :label="mod || '未分组'">
                <Option v-for="role in roleGroup" :value="role.id" :key="role.id">{{ role.name }}</Option>
              </OptionGroup>
            </Select>

            <!-- 群组选择 -->
            <Select
              v-if="addPermissionForm.clientType === 'group'"
              v-model="addPermissionForm.clientId"
              placeholder="选择群组"
              style="width: 100%;"
              filterable
            >
              <Option v-for="group in groups" :value="group.id" :key="group.id">{{ group.name }}</Option>
            </Select>
          </FormItem>
        </div>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modules: [],
      searchQuery: '',
      currentGroup: 'all',
      loading: false,
      confirmLoading: false,
      modalVisible: false,
      modalTitle: '添加模块',
      currentId: null,
      page: 1,
      pageSize: 20,
      formData: this.getInitialFormData(),

      // 授权相关
      permissionModalVisible: false,
      currentModule: null,
      permissions: [],
      permissionLoading: false,
      roles: [],
      groups: [],
      permissionColumns: [
        {
          title: '授权类型',
          key: 'client_type',
          width: 100,
          align: 'center',
          render: (h, {row})=>{
            const typeMap = {
              'user': {text: '用户', color: 'blue'},
              'role': {text: '角色', color: 'green'},
              'group': {text: '群组', color: 'orange'},
            };
            const type = typeMap[row.client_type] || {text: '未知', color: 'default'};
            return h('Tag', {props: {color: type.color}}, type.text);
          },
        },
        {
          title: '授权对象',
          key: 'client_id',
          width: 200,
          render: (h, {row})=>{
            if (row.client_type === 'user') {
              return h('BaseNameBoard', {props: {uid: row.client_id}});
            } else if (row.client_type === 'role') {
              const role = this.roles.find((r) => r.id == row.client_id);
              return h('span', {style: {fontWeight: '500'}}, role ? role.name : row.client_id);
            } else if (row.client_type === 'group') {
              const group = this.groups.find((g) => g.id == row.client_id);
              return h('span', {style: {fontWeight: '500'}}, group ? group.name : row.client_id);
            }
            return h('span', '-');
          },
        },
        {title: '授权时间', key: 'created_at', minWidth: 200},
        {
          title: '操作',
          slot: 'action',
          width: 100,
          align: 'center',
        },
      ],

      columns: [
        {type: 'index', width: 80, title: '序号'},
        {
          title: '分组',
          key: 'group',
          render: (h, params) => {
            if (!params.row.group || params.row.group.trim() === '') {
              return h('span', {
                style: {
                  color: '#999',
                  fontStyle: 'italic',
                },
              }, '未分组');
            }
            return h('Tag', {
              props: {
                color: 'blue',
              },
            }, params.row.group);
          },
        },
        {
          title: '图标',
          key: 'icon',
          width: 100,
          sortable: false,
          render: (h, params) => {
            return h('div', {
              style: {
                textAlign: 'center',
                padding: '4px',
                background: '#f5f5f5',
                borderRadius: '4px',
                width: '36px',
                margin: '0 auto',
              },
            }, [
              h('BaseIcon', {
                props: {
                  icon: params.row.icon,
                },
                style: {
                  fontSize: '20px',
                },
              }),
            ]);
          },
        },
        {
          title: '名称',
          key: 'name',
          render: (h, params) => {
            return h('div', [
              h('strong', params.row.name),
            ]);
          },
        },
        {
          title: '开发中',
          key: 'developing',
          width: 90,
          align: 'center',
          render: (h, params) => {
            if (!params.row.developing) return h('span', {style: {color: '#ccc'}}, '否');
            return h('Tag', {
              props: {
                color: 'orange',
              },
            }, '开发中');
          },
        },
        {
          title: '描述',
          key: 'description',
          render: (h, params) => {
            if (!params.row.description) return h('span', {style: {color: '#ccc'}}, '暂无描述');
            return h('Tooltip', {
              props: {
                content: params.row.description,
                maxWidth: 300,
              },
            }, [
              h('span', params.row.description.length > 30 ?
                params.row.description.substring(0, 30) + '...' :
                params.row.description),
            ]);
          },
        },
        {
          title: 'Base URL',
          key: 'base_url',
          render: (h, params) => {
            if (!params.row.base_url) return h('span', {style: {color: '#ccc'}}, '-');
            return h('span', {
              style: {
                fontFamily: 'monospace',
                background: '#f5f5f5',
                padding: '2px 4px',
                borderRadius: '3px',
              },
            }, params.row.base_url);
          },
        },
        {
          title: 'URL',
          key: 'url',
          render: (h, params) => {
            if (!params.row.url) return h('span', {style: {color: '#ccc'}}, '-');
            return h('span', {
              style: {
                fontFamily: 'monospace',
                background: '#f5f5f5',
                padding: '2px 4px',
                borderRadius: '3px',
                color: '#1890ff',
              },
            }, params.row.url);
          },
        },
        {
          title: '版本',
          key: 'version',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: 'green',
              },
            }, 'v' + params.row.version);
          },
        },
        {
          title: '状态',
          key: 'status',
          render: (h, params) => {
            const badges = [];

            if (params.row.private) {
              badges.push(h('Tag', {
                props: {
                  color: 'red',
                },
                style: {
                  marginRight: '5px',
                },
              }, '私有'));
            }

            // 添加权限等级标签
            const level = this.plevelOptions.find((o) => o.id === params.row.plevel);
            const levelColors = {
              0: 'green',
              1: 'blue',
              2: 'purple',
              3: 'magenta',
            };

            if (level) {
              badges.push(h('Tag', {
                props: {
                  color: levelColors[params.row.plevel] || 'default',
                },
              }, level.name));
            }

            return h('div', badges);
          },
        },
        {type: 'time', title: '创建时间', key: 'created_at'},
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            const buttons = [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleEdit(params.row);
                  },
                },
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleDelete(params.row);
                  },
                },
              }, '删除'),
            ];

            // 为私有模块添加授权按钮
            if (params.row.private) {
              buttons.splice(1, 0, h('Button', {
                props: {
                  type: 'warning',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handlePermissions(params.row);
                  },
                },
              }, '授权'));
            }

            return h('div', buttons);
          },
        },
      ],
      plevelOptions: [
        {name: '全部用户', id: 0},
        {name: '企业用户', id: 1},
        {name: '企业管理员', id: 2},
        {name: '超级管理员', id: 3},
      ],
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        icon: [{required: true, message: '请选择图标', trigger: 'change'}],
      },
      addPermissionModalVisible: false,
      addPermissionForm: {
        clientType: 'user',
        clientId: null,
      },
      addPermissionRules: {
        clientType: [{required: true, message: '请选择授权类型', trigger: 'change'}],
        clientId: [{required: true, message: '请选择授权对象', trigger: 'change'}],
      },
      addPermissionLoading: false,
      groupedRoles: {},
    };
  },
  computed: {
    availableGroups() {
      // 获取所有非空的唯一分组
      const groups = [...new Set(this.modules
          .map((item) => item.group)
          .filter((group) => group && group.trim() !== ''))];

      return groups.sort();
    },
    filteredModules() {
      let result = [...this.modules];

      // 先按分组筛选
      if (this.currentGroup !== 'all') {
        if (this.currentGroup === '') {
          // 筛选未分组的数据
          result = result.filter((module) => !module.group || module.group.trim() === '');
        } else {
          // 筛选特定分组的数据
          result = result.filter((module) => module.group === this.currentGroup);
        }
      }

      // 再按搜索词筛选
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter((module) =>
          (module.name && module.name.toLowerCase().includes(query)) ||
          (module.description && module.description.toLowerCase().includes(query)),
        );
      }

      return result;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getGroupModuleCount(group) {
      if (group === '') {
        return this.modules.filter((m) => !m.group || m.group.trim() === '').length;
      }
      return this.modules.filter((m) => m.group === group).length;
    },
    handleGroupChange(group) {
      this.currentGroup = group;
      this.page = 1; // 重置到第一页
    },
    getInitialFormData() {
      return {
        name: '新模块',
        icon: 'apps',
        description: '',
        group: '',
        base_url: '',
        url: '/core/new',
        version: 1,
        private: false,
        developing: false,
        plevel: 0,
      };
    },
    handleSearch() {
      this.page = 1; // 重置到第一页
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await this.$api.get('/admin/mods');
        this.modules = response.data.data;
      } catch (error) {
        this.$Message.error('获取模块列表失败');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleTableEvent(e) {
      const {type, data} = e;
      switch (type) {
        case 'select':
          this.currentId = data;
          break;
        case 'page-change':
          this.page = data;
          break;
        case 'page-size-change':
          this.pageSize = data;
          break;
      }
    },
    handleAdd() {
      this.modalTitle = '添加模块';
      this.formData = this.getInitialFormData();
      this.currentId = null;
      this.modalVisible = true;
    },
    handleEdit(record) {
      this.modalTitle = '编辑模块';
      this.formData = {...record};
      this.currentId = record.id;
      this.modalVisible = true;
    },
    async handleDelete(record) {
      try {
        await this.$api.delete(`/admin/mods/${record.id}`);
        this.$Message.success('删除成功');
        this.fetchData();
      } catch (error) {
        this.$Message.error('删除失败');
        console.error(error);
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        if (this.currentId) {
          // 更新
          await this.$api.patch(`/admin/mods/${this.currentId}`, this.formData);
          this.$Message.success('更新成功');
        } else {
          // 新增
          await this.$api.post('/admin/mods', this.formData);
          this.$Message.success('添加成功');
        }

        this.modalVisible = false;
        this.fetchData();
      } catch (error) {
        this.$Message.error(error.message || '提交失败');
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    async handlePermissions(record) {
      this.currentModule = record;
      this.permissionModalVisible = true;

      // 并行获取权限、角色和群组数据
      await Promise.all([
        this.fetchPermissions(),
        this.fetchRoles(),
        this.fetchGroups(),
      ]);
    },
    async fetchPermissions() {
      if (!this.currentModule) return;

      this.permissionLoading = true;
      try {
        const response = await this.$api.get(`/admin/permissions?target_id=${this.currentModule.id}&target_type=module`);
        this.permissions = response.data.data || [];
      } catch (error) {
        this.$Message.error('获取授权信息失败');
        console.error(error);
      } finally {
        this.permissionLoading = false;
      }
    },
    async fetchRoles() {
      try {
        const response = await this.$api.get('/admin/roles');
        this.roles = response.data.data || [];
        this.groupedRoles = this.groupRolesByMod(this.roles);
      } catch (error) {
        this.$Message.error('获取角色列表失败');
        console.error(error);
      }
    },
    async fetchGroups() {
      try {
        const response = await this.$api.get('/admin/groups');
        this.groups = response.data.data || [];
      } catch (error) {
        this.$Message.error('获取群组列表失败');
        console.error(error);
      }
    },
    async handleAddPermission() {
      try {
        await this.$refs.addPermFormRef.validate();
        this.addPermissionLoading = true;

        await this.$api.post('/admin/permissions', {
          target_id: this.currentModule.id,
          target_type: 'module',
          client_type: this.addPermissionForm.clientType,
          client_id: this.addPermissionForm.clientId,
        });

        this.$Message.success('添加授权成功');
        this.addPermissionModalVisible = false;
        this.addPermissionForm = {
          clientType: 'user',
          clientId: null,
        };
        this.fetchPermissions();
      } catch (error) {
        this.$Message.error('添加授权失败');
        console.error(error);
      } finally {
        this.addPermissionLoading = false;
      }
    },
    async handleDeletePermission(permission) {
      try {
        await this.$api.delete(`/admin/permissions/${permission.id}`);
        this.$Message.success('删除授权成功');
        this.fetchPermissions();
      } catch (error) {
        this.$Message.error('删除授权失败');
        console.error(error);
      }
    },
    showAddPermissionModal() {
      this.addPermissionModalVisible = true;
    },
    handleSetClientType(type) {
      this.addPermissionForm.clientType = type;
      this.addPermissionForm.clientId = null;
    },
    groupRolesByMod(roles) {
      return roles.reduce((acc, role) => {
        if (!acc[role.mod]) {
          acc[role.mod] = [];
        }
        acc[role.mod].push(role);
        return acc;
      }, {});
    },
  },
};
</script>

<style>
.search-bar {
  border-bottom:1px solid var(--border);
  padding: 15px;
  background: #fff;
  display: flex;
  align-items: center;
}

.group-filter {
  display: flex;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 4px;
  padding: 10px 15px;
}

.group-item {
  padding: 5px 12px;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.3s;
  position: relative;
  margin-bottom: 5px;
}

.group-item:hover {
  background: #f0f0f0;
}

.group-item.active {
  background: #e6f7ff;
  color: #1890ff;
  font-weight: 500;
}

.group-item .count {
  font-size: 12px;
  background: #f0f0f0;
  border-radius: 10px;
  padding: 0 6px;
  margin-left: 5px;
  color: #666;
}

.group-item.active .count {
  background: #1890ff;
  color: #fff;
}

.table-wrapper {
  position: relative;
  height: calc(100vh - 160px);
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}


.form-section {
  margin-bottom: 20px;
}

.form-section h3 {
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-row {
  display: flex;
  margin: 0 -8px;
}

.form-item {
  padding: 0 8px;
  flex: 1;
}

.perm-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.perm-module-info {
  display: flex;
  align-items: center;
}

.module-info-text h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.module-desc {
  font-size: 12px;
  color: #666;
  margin-top: 2px;
  display: block;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.perm-actions {
  display: flex;
  align-items: center;
}

.icon-select-wrapper {
  display: inline-block;
  width:100%;
}

.add-perm-form-row {
  display: flex;
  margin: 0 -8px;
}

.add-perm-form-col {
  padding: 0 8px;
  flex: 1;
}
</style>
